import { InputChoices } from 'views/components/molecules/establishes/inputChoices';
import {
  InvestmentInfoFormikType,
  PolicyStrs,
  AnnualIncomeStrs,
  FinancialAssetsStrs,
  Experiences,
  FormErrorScrollTarget,
} from 'views/utils/accountEstablish';
import { Button, ButtonProps } from 'views/components/atoms/button';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { CheckBoxGloup } from 'views/components/molecules/checkBoxGroup';

type InvestmentInfoTemplateType = {
  formik: InvestmentInfoFormikType;
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
    confirmButtonProps: ButtonProps;
    isPrevPageConfirm: boolean;
  };
};

export const InvestmentInfoTemplate = ({ formik, buttonProps }: InvestmentInfoTemplateType) => {
  return (
    <>
      <div className="establishWrapper ">
        <div className="establishWrapper_announce">
          <h1>取引の種類</h1>
          <h2>受益証券発行信託の受益証券の募集の取扱い・売買</h2>
        </div>
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.investmentExperiences && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'証券投資のご経験'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.investmentExperiences}
            cb={(items) => {
              formik.setFieldValue('investmentExperiences', items);
            }}
            exclusiveItem={Experiences.NO_EXPERIENCE}
          />
          <EstablishError
            isEnabled={!!(formik.errors.investmentExperiences as string)}
            errorText={formik.errors.investmentExperiences as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.investmentPolicy && <FormErrorScrollTarget />}
        <InputChoices
          title="ご投資の方針"
          batchDangerWord="必須"
          selectedOption={formik.values.investmentPolicy ? formik.values.investmentPolicy : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('investmentPolicy', selectedOption)}
          options={PolicyStrs}
          isEnabled={!!formik.errors.investmentPolicy}
          errorText={formik.errors.investmentPolicy}
        />
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.investmentPurposes && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'弊社ご利用にあたってのご投資目的'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.investmentPurposes}
            cb={(items) => {
              formik.setFieldValue('investmentPurposes', items);
            }}
          />
          <EstablishError
            isEnabled={!!(formik.errors.investmentPurposes as string)}
            errorText={formik.errors.investmentPurposes as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.annualIncome && <FormErrorScrollTarget />}
        <InputChoices
          title="年収"
          batchDangerWord="必須"
          selectedOption={formik.values.annualIncome ? formik.values.annualIncome : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('annualIncome', selectedOption)}
          options={AnnualIncomeStrs}
          isEnabled={!!formik.errors.annualIncome}
          errorText={formik.errors.annualIncome}
        />
      </div>

      <div className="establishWrapper">
        <div className="inputWrapper">
          {!!formik.errors.incomeForm && <FormErrorScrollTarget />}
          <EstablishHeader headerTitle={'収入形態'} batchDangerWord="必須（複数選択可）" />
          <CheckBoxGloup
            items={formik.values.incomeForm}
            cb={(items) => {
              formik.setFieldValue('incomeForm', items);
            }}
          />
          <EstablishError
            isEnabled={!!(formik.errors.incomeForm as string)}
            errorText={formik.errors.incomeForm as string}
          />
        </div>
      </div>

      <div className="establishWrapper">
        {!!formik.errors.financialAssets && <FormErrorScrollTarget />}
        <InputChoices
          title="金融資産"
          batchDangerWord="必須"
          selectedOption={formik.values.financialAssets ? formik.values.financialAssets : ''}
          setSelectedOption={(selectedOption) => formik.setFieldValue('financialAssets', selectedOption)}
          options={FinancialAssetsStrs}
          isEnabled={!!formik.errors.financialAssets}
          errorText={formik.errors.financialAssets}
        />
      </div>

      {buttonProps && (
        <div className="establishWrapper">
          {buttonProps.isPrevPageConfirm ? (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.confirmButtonProps} />
            </div>
          ) : (
            <div className="establishWrapper_buttons">
              <Button {...buttonProps.prevButtonProps} />
              <Button {...buttonProps.nextButtonProps} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
